import { IDefaultComponentProps } from '@src/models/props';
import React, { FC } from 'react';
import ContentLoader, { IContentLoaderProps } from 'react-content-loader';
import { classnames } from '@src/utils/classnames';
import { BACKGROUND_COLOR, DEFAULT_TITLE, FOREGROUND_COLOR } from './consts';
import styled from './skeleton.scss';

export interface ISkeletonProps extends IDefaultComponentProps, IContentLoaderProps {}

/**
 * Компонент для отображения статуса загрузки
 * Используйте подкомпоненты `Rect` и `Circle`
 *
 * Подкомпонент `Rect` настроен по умолчанию занимать всю ширину родительского контейнера,
 * но вы всегда можете указать конкретное значение ширины и высоты
 */
export const Skeleton: FC<ISkeletonProps> = ({ children, className, width, height, backgroundColor, ...rest }) => {
  const classes = classnames(className, styled.root, {
    [styled.fullHeight]: !height,
    [styled.fullWidth]: !width,
  });

  return (
    <ContentLoader
      className={classes}
      title={DEFAULT_TITLE}
      backgroundColor={backgroundColor ?? BACKGROUND_COLOR}
      foregroundColor={FOREGROUND_COLOR}
      height={height}
      width={width}
      {...rest}
    >
      {children}
    </ContentLoader>
  );
};
